import styled, { css } from 'styled-components';
import { Body, Overline, Subtitle, Caption } from 'components/Typography';
import addAlpha from 'utils/addAlpha';

const LEFT_SPACE = '3rem';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 1.5rem;
  height: fit-content;
`;

export const Category = styled(Overline)`
  margin-left: ${LEFT_SPACE};
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  margin-bottom: 0.6875rem;
  display: inline-block;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  margin-bottom: 0.9375rem;
`;

export const Number = styled(Caption)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  background-color: ${({ theme }) => theme.colors.navyGreen};
  color: ${({ theme }) => theme.colors.white};
  margin-right: 1rem;
`;

export const Name = styled(Subtitle)`
  font-weight: 600;
`;

export const Prize = styled(Subtitle)`
  font-weight: 600;
`;

export const PrizeModifiers = styled(Body)`
  color: ${({ theme }) => theme.colors.navyGreen};
`;

export const SectionTitle = styled(Body)`
  margin-left: ${LEFT_SPACE};
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  margin-bottom: 0.5625rem;
`;

export const Instruction = styled(Body)`
  margin-left: ${LEFT_SPACE};
  color: ${({ theme }) => theme.colors.navyGreen};
  margin-bottom: 0.5625rem;
`;

export const Separator = styled.div`
  margin: 1.625rem 0;
  background-color: ${({ theme }) => theme.colors.gray2};
  height: 0.0625rem;
  width: 100%;
`;

export const Modifier = styled(Body)`
  color: ${({ theme }) => theme.colors.navyGreen};
  margin-bottom: 0.5625rem;
  flex: 1;
`;

export const Product = styled.div`
  width: 100%;
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Quantity = styled(Number)`
  background-color: transparent;
  color: inherit;
`;

const FINAL_PRIZE_STYLES = css`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: ${LEFT_SPACE};
`;

export const Taxes = styled(Body)`
  ${FINAL_PRIZE_STYLES};
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  margin-bottom: 0.5625rem;
`;

export const Discount = styled(Taxes)``;

export const Subtotal = styled(Body)`
  ${FINAL_PRIZE_STYLES};
  color: ${({ theme }) => theme.colors.navyGreen};
  margin-bottom: 0.5625rem;
`;

export const Total = styled(Subtitle)`
  ${FINAL_PRIZE_STYLES};
  font-weight: 600;
`;

export const PleaseLabel = styled(Body)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  font-size: 1.0625rem;
  margin-left: 1rem;
  margin-right: 0.5rem;
`;

export const Label = styled.div`
  border-radius: 3rem;
  background: #e4f8f0;
  color: #3dc694;
  padding: 0.25rem 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2rem;
`;

export const Group = styled.div`
  display: flex;
  flex: 1;
  align-items: baseline;
`;
